import HttpRequest from '@/config/axios.config'

export async function getRolePermissionRef() {
  return await HttpRequest.get('/permissions/role-permissions')
}
